import R from 'ramda';
import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import * as steps from 'common/steps';
import { appError } from 'application/applicationActions';
import * as contactInfoActions from './contactInfoActions';
import * as submissionActions from 'submission/submissionActions';

import {
  createAcknowledgeSubmissionEpic,
  createCompleteStepEpic,
  createLoadLocalStorageEpic,
  createSyncLocalStorageEpic,
} from 'common/stepEpicUtil';

import { fetchCountries, fetchSubdivisions } from 'common/stipAjax';

import {
  getFields,
  getCompleted,
  getLoadingInitData,
  getLoadingLocalStorage,
} from 'common/stepReducerUtil';

import { getActiveStep } from 'submission/submissionReducer';

const fetchInitData = state => {
  const fields = getFields(state.contactInfo);
  const countryCode = R.path(['permanentAddress', 'country', 'code'], fields);

  return Observable.forkJoin(
    fetchCountries(),
    !R.isNil(countryCode) ? fetchSubdivisions(countryCode) : Observable.of([]),
  );
};

const fetchInitDataFilter = (state, action) => {
  const { contactInfo, submission } = state;
  const loadingLocalStorage = getLoadingLocalStorage(contactInfo);
  const loadingInitData = getLoadingInitData(contactInfo);
  const activeStep = getActiveStep(submission);

  return (
    loadingInitData &&
    activeStep === steps.CONTACT_INFO &&
    ((!loadingLocalStorage &&
      action.type === submissionActions.LOCAL_STORAGE_LOADED) ||
      (!loadingLocalStorage &&
        action.type === submissionActions.SET_ACTIVE_STEP) ||
      (!loadingLocalStorage &&
        action.type === submissionActions.INVALID_SUBMISSION) ||
      action.type === contactInfoActions.LOCAL_STORAGE_LOADED)
  );
};

const fetchInitDataEpic = (action$, store) =>
  action$
    .filter(action => fetchInitDataFilter(store.getState(), action))
    .mergeMap(() =>
      fetchInitData(store.getState())
        .map(([countries, administrativeAreas]) =>
          contactInfoActions.initDataLoaded(countries, administrativeAreas),
        )
        .catch(R.pipe(appError, Observable.of)),
    );

const loadAdministrativeAreasEpic = (action$, store) =>
  action$
    .ofType(contactInfoActions.COUNTRY_CHANGED)
    .mergeMap(action =>
      fetchSubdivisions(action.countryCode)
        .map(contactInfoActions.administrativeAreasLoaded)
        .catch(R.pipe(appError, Observable.of)),
    );

const syncLocalStorageEpic = createSyncLocalStorageEpic(
  [
    submissionActions.CANCEL_SUBMISSION,
    submissionActions.SUBMIT,
    contactInfoActions.ADMINISTRATIVE_AREA_CHANGED,
    contactInfoActions.CITIZENSHIP_CHANGED,
    contactInfoActions.COMPLETE_STEP,
    contactInfoActions.COUNTRY_CHANGED,
    contactInfoActions.FIELD_CHANGED,
  ],
  {
    completed: getCompleted,
    fields: getFields,
  },
  contactInfoActions.localStorageSynced,
  steps.CONTACT_INFO,
);

export default combineEpics(
  createLoadLocalStorageEpic(
    steps.CONTACT_INFO,
    contactInfoActions.localStorageLoaded,
  ),
  syncLocalStorageEpic,
  fetchInitDataEpic,
  loadAdministrativeAreasEpic,
  createAcknowledgeSubmissionEpic(steps.CONTACT_INFO),
  createCompleteStepEpic(contactInfoActions.COMPLETE_STEP, steps.CONTACT_INFO),
);



// WEBPACK FOOTER //
// ./src/contact-info/contactInfoEpic.js